import React from 'react';

export default function Team() {
    return (
        <div>
            <h4 className="mb-3">Team</h4>
            <h5>PhD candidates</h5>
            <ul>
                <li>
                    <a
                        href="https://www.tudelft.nl/staff/i.besnea/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Irina Besnea
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.tudelft.nl/staff/j.a.vanthoff/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Jurriaan van &apos;t Hoff
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.tudelft.nl/staff/l.kavabata/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Luccas Kavabata
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.eng.cam.ac.uk/profiles/zer23"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Zain Robson
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.eng.cam.ac.uk/profiles/ld642"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Leven Davies
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.eng.cam.ac.uk/profiles/vs503"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Vidhi Sharma
                    </a>
                </li>
            </ul>
            <h5>Postdocs</h5>
            <ul>
                <li>
                    <a
                        href="https://www.tudelft.nl/staff/f.quadros/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Flávio Quadros
                    </a>
                    , PhD (2019-2023), Postdoc (2023-now){' '}
                    <a href="https://doi.org/10.4233/uuid:b54561bd-1141-429f-83e3-a94b966c7a07">
                        [PhD Thesis]
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.eng.cam.ac.uk/profiles/sim31"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Sofia Medina Cassillas
                    </a>
                </li>
            </ul>
            <h5>MSc/MEng students</h5>
            <ul></ul>
            <h5>Previous members</h5>
            <ul>
                <li>
                    <a
                        href="https://www.tudelft.nl/staff/j.maruhashi/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Jin Maruhashi
                    </a>
                    , PhD (2020-2024), Postdoc (2024){' '}
                    <a href="https://doi.org/10.4233/uuid:177577f9-d99c-4d57-a7a2-5142cce8c03d">
                        [PhD Thesis]
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.tudelft.nl/staff/j.maes/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Jeff Maes
                    </a>
                    , MSc (2020-2021), Researcher (2021-2026)
                </li>
                <li>
                    Vincent Verhoeven, MSc (2019-2020), Researcher (2020-2021)
                </li>
                <li>Max Howard, MEng (2024-2025)</li>
                <li>Yeming Ba, MEng (2024-2025)</li>
                <li>Ayushman Nath, MEng (2024-2025)</li>
                <li>Samuel Otterloo, MSc (2022-2024)</li>
                <li>Yvar Vliex, MSc (2023-2024)</li>
                <li>Xander van Hal, MSc (2023-2024)</li>
                <li>Jeltes de Weerd, MSc (at to70, 2023-2024)</li>
                <li>Tom van Cranenburgh, MSc (2023-2024)</li>
                <li>Jaime Aalders, MSc (2023-2024)</li>
                <li>Lidia Rzeplinska, MSc (2021-2023)</li>
                <li>Edoardo Verzotti, MSc (2022-2023)</li>
                <li>Rik Goudswaard, MSc (2021-2023)</li>
                <li>Rick Nelen, MSc (2022-2023)</li>
                <li>Liesbeth Wijn, MSc (2022-2023)</li>
                <li>Harry Aldridge, MSc (2020-2022)</li>
                <li>Mathieu Blanke, MSc (2020-2021)</li>
                <li>Lodewijck Foorthuis, MSc (at SRON, 2021-2022)</li>
                <li>Mariijn van Loo, MSc (2020-2021)</li>
                <li>Pratik Rindhe, MSc (at SRON, 2021-2022)</li>
                <li>
                    Morgane Bourgeois, MSc Exchange Research Internship, 2020
                </li>
            </ul>
        </div>
    );
}
